// src/data/verses.js
import kjv from './kjv.json';
import niv from './niv.json';

const allVerses = {
    kjv,
    niv
};

export default allVerses;
